__turbopack_context__.v({
  "root": "PlantCodePicker-module-scss-module__hFpUjW__root",
  "select": "PlantCodePicker-module-scss-module__hFpUjW__select",
});
